import { Component, ElementRef, inject, OnDestroy, Renderer2, OnInit, signal } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { Router, RouterLink } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { CartService } from '../../services/cart.service';
import { EmailVerifyBadge } from '../../../shared/components/email-verify-badge/email-verify-badge';

@Component({
  selector: 'app-header',
  imports: [CommonModule, RouterLink, EmailVerifyBadge],
  templateUrl: './header.html',
   host: {
    '(window:scroll)': 'onScroll($event)', // Listen to the scroll event
  }
})
export class Header implements OnInit, OnDestroy {
  private authService = inject(AuthService);
  private router = inject(Router);
  currentUser = this.authService.currentUser;
  cartService = inject(CartService);

  // Drives the logged-in avatar so a signed-in user sees who they are instead of the same generic
  // icon shown to a guest. Shared with the admin/business layouts via AuthService.
  userInitials = this.authService.userInitials;

  // Storefront logout goes back to the homepage (standard e-commerce practice - keeps the
  // customer shopping as a guest), not the /logged-out confirmation page used by Admin/Business,
  // which have no public page to fall back to. See CLAUDE.md.
  async logout(): Promise<void> {
    await this.authService.signOut();
    this.router.navigateByUrl('/');
  }

  menuOpen = signal(false);
  menuArray = signal<any[]>([]);
  contactNumber = signal('+91 7977828078');
  tabs = [
    { id: 'wellGro', label: 'WellGro' },
    { id: 'wellPro', label: 'WellPro' },
    { id: 'bewell', label: 'BeWell' },
    { id: 'breathePure', label: 'BreathePure' }
  ];

  activeTab = signal(this.tabs[0].id);
   private readonly sanitizer = inject(DomSanitizer);
   // Signal for the sanitized URL
  readonly safeVoidUrl: SafeUrl = this.sanitizer.bypassSecurityTrustUrl('javascript:void(0)');

  private crPrevScroll = 0;
  private crDirection = 0;
  private crPrevDirection = 0;

  private renderer = inject(Renderer2);
  private el = inject(ElementRef);


  ngOnInit(): void {
    this.menuArray.set([
      {
        id : '1',
        title: 'Home',
        route: '/home',
      },
      {
        id : '2',
        title: 'Our Brands',
        route: '',
        children: [
           {
            id: '2-2',
            title: 'wellgro',
            route: '/our-brands/wellgro',
          },
          {
             id: '2-1',
            title: 'wellpro',
            route: '/our-brands/wellpro',
          },
         
          {
            id: '2-3',
            title: 'breathepure',
            route: '/our-brands/breathepure',
          }
          ,
          {
            id : '2-4',
            title: 'bwell',
            route: '/our-brands/bwell',
          }
          
          
        ],
      },

      {
        id: '3',
        title: 'Products',
        route: '/products',
      },

       {
        id: '6',
        title: 'Skill Development',
        route: '/skill-development'
      },
       {
        id: '7',
        title: 'About',
        route: '/about',
      },
      {
        id: '8',
        title: 'Contact',
        route: '/contact',
      }
    ]);
  }

  ngOnDestroy(): void {}
  openMobileMenu(): void {
    console.log('Toggling menu');
    this.menuOpen.update((open) => !open);
  }

  closeMobileMenu(): void {
    console.log('Toggling menu');
    this.menuOpen.update((open) => !open);
  }

  toggleSubMenu(event: Event): void {
    const target = event.currentTarget as HTMLElement;
    const subMenu = target.querySelector('.sub-menu');

    if (subMenu) {
      subMenu.classList.toggle('hidden');
    }

    // Prevent event bubbling if necessary
    event.stopPropagation();
  }
   selectTab(tabId: string) {
    this.activeTab.set(tabId);
  }

  onScroll(event: Event) {
    const doc = document.documentElement;
    const w = window;
    const crCurScroll = w.scrollY || doc.scrollTop;

    if (crCurScroll > this.crPrevScroll) {
      // Scrolled up
      this.crDirection = 2;
    } else if (crCurScroll < this.crPrevScroll) {
      // Scrolled down
      this.crDirection = 1;
    }

    if (this.crDirection !== this.crPrevDirection) {
      this.toggleHeader(this.crDirection, crCurScroll);
    }

    this.crPrevScroll = crCurScroll;

    // Check distance for removing the fixed menu
    const distance = this.el.nativeElement.querySelector('.next, .section-breadcrumb')?.offsetTop || 0;
    if (w.scrollY <= distance + 5) {
      this.renderer.removeClass(this.el.nativeElement.querySelector('#cr-main-menu-desk'), 'menu_fixed');
    }
  }

  private toggleHeader(crDirection: number, crCurScroll: number) {
    const menu = this.el.nativeElement.querySelector('#cr-main-menu-desk');

    if (crDirection === 2 && crCurScroll > -46) {
      this.crPrevDirection = crDirection;
      this.renderer.addClass(menu, 'menu_fixed_up');
    } else if (crDirection === 1) {
      this.crPrevDirection = crDirection;
      this.renderer.addClass(menu, 'menu_fixed');
      this.renderer.removeClass(menu, 'menu_fixed_up');
    }
  }
}
